import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  NavbarToggler,
  Collapse
} from "reactstrap";
import { useState } from "react";
import logo from "../../public/img/logo.png";
import MainButton from "../Button/MainButton";
import { navbarLogoStyles, navbarStyles, navigationAnimation } from "../styles/mainStyles";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../Service/Variables/Common";
import LogoutButton from "../Button/LogoutButton";
import UserService from "../../Service/API/UserService";

function CommonNavbar() {
  const navigation = useNavigate()
  const userData = getUserData()
  const userService = new UserService()
  const username = userData.username
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  function handleClick () {
    navigation(`/login?`)
  }

  async function handleLogout () {
    try {
      await userService.LogOut()
      navigation('/')
    } catch (error) {
      console.log(error.message)
    }
  }

  return (
    <Navbar
      expand="md"
      light
      fixed="top"
      className="px-4 shadow-sm"
      style={navbarStyles}
    >
      <NavbarBrand href="/" className="d-flex align-items-center fw-bold">
        <img
          src={logo}
          alt="Goodnet Logo"
          style={navbarLogoStyles}
          className="me-2"
        />
      </NavbarBrand>
      <NavbarToggler onClick={toggle} />
      <Collapse isOpen={isOpen} navbar>
        <Nav className="ms-auto align-items-center" navbar>
          <NavItem>
            <NavLink
              href="/home"
              className="fw-semibold mx-2"
              style={navigationAnimation}
            >
              Home
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              href="/cara-bayar"
              className="fw-semibold mx-2"
              style={navigationAnimation}
            >
              Cara Bayar
            </NavLink>
          </NavItem>
          {!username ? (<></>)
              : (<>
              <NavItem>
                <NavLink
                  className="fw-semibold mx-2"
                  >Hallo, {username}
                </NavLink>
              </NavItem>
              </>)
          }
          <NavItem>
          {!username ? (<>
              <MainButton
                title={"masuk"}
                size = {'sm'}
                onClick={handleClick}
              />
          </>)
              : (<>
                <LogoutButton
                  title={"Logout"}
                  size = {'sm'}
                  onClick={handleLogout}
                />
              </>)
          }
          </NavItem>
        </Nav>
      </Collapse>
    </Navbar>
  );
}

export default CommonNavbar;
